'use client'

import { FileText } from 'react-feather'
import { useTranslations } from '@/lib/next-shim'

import { DocumentsSection } from '@/features/documents'
import { objectTypes } from '@/core/api/modules/document'

import type { DocumentFile } from '../model/types'

type DocumentsClientProps = {
  patientFiles: DocumentFile[]
  consultationFiles: DocumentFile[]
  patientId: string
  objectType: (typeof objectTypes)[number]
  error?: string
}

export function DocumentsList({ patientFiles, consultationFiles, patientId, objectType, error }: DocumentsClientProps) {
  const t = useTranslations()

  if (error) {
    return (
      <div className="mx-auto w-full max-w-6xl rounded-lg bg-red-50 p-4 text-sm text-red-600" role="alert">
        {error}
      </div>
    )
  }

  const totalCount = patientFiles.length + consultationFiles.length

  return (
    <div className="mx-auto flex w-full max-w-6xl flex-col gap-8">
      <header className="flex flex-col gap-1.5 px-5">
        <div className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary/10 text-primary">
            <FileText size={18} aria-hidden="true" />
          </span>
          <h1 className="section-title text-xl md:text-2xl">{t('account.navigationMenu.accountDocuments.label')}</h1>
          {totalCount > 0 && <span className="rounded-full bg-primary/10 px-2 py-0.5 text-xs font-semibold tabular-nums text-primary">{totalCount}</span>}
        </div>
        <p className="text-sm text-gray-500">{t('page.AccountDocuments.subtitle')}</p>
      </header>

      <DocumentsSection files={patientFiles} title={t('page.AccountDocuments.patientFiles.title')} showUploadButton objectType={objectType} objectId={patientId} />
      <DocumentsSection files={consultationFiles} title={t('page.AccountDocuments.consultationFiles.title')} showUploadButton={false} />
    </div>
  )
}
